/**
 * @file index
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import zh_CN from './components/locale/zh_CN';
import en_US from './components/locale/en_US';

export * from './components';
export * from './utils';
export * from './hooks';

export const locales = {zh_CN, en_US};
